import { useMemo } from 'react';
import { Typography, Tag, Tooltip } from 'antd';
import { SmartDataTableProps } from '@src/components/SmartDataTable/types';
import { useUserTimestampRender } from '@src/hooks/useUserTimestampRender';
import { usePaymentTypeRender } from './usePaymentTypeRender';

const { Text } = Typography;

export const useInsideStockTransactionsColumns =
  (): SmartDataTableProps['columns'] => {
    const userTimestampRender = useUserTimestampRender();
    const renderPaymentType = usePaymentTypeRender();

    return useMemo(
      () => [
        {
          key: 'id',
          title: 'ID',
          dataIndex: 'id',
          sorter: true,
          minWidth: 80,
          ellipsis: true,
          render: (value: any) => (
            <Text
              style={{
                fontSize: '12px',
                color: '#8c8c8c',
                backgroundColor: '#f5f5f5',
                padding: '2px 6px',
                borderRadius: '4px',
              }}
            >
              #{value}
            </Text>
          ),
        },
        {
          key: 'purchase_id',
          title: 'Purchase ID',
          dataIndex: 'purchase',
          sorter: true,
          minWidth: 120,
          ellipsis: true,
          render: (purchase: any, record: any) => {
            const tooltipContent = (
              <div style={{ maxWidth: '250px' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                  Purchase Details
                </div>
                <div style={{ marginBottom: '4px' }}>
                  <strong>ID:</strong> {purchase?.id || 'N/A'}
                </div>
                <div style={{ marginBottom: '4px' }}>
                  <strong>Invoice ID:</strong> {purchase?.invoice_id || 'N/A'}
                </div>
                <div style={{ marginBottom: '4px' }}>
                  <strong>Supplier:</strong> {purchase?.supplier_name || 'N/A'}
                </div>
                <div>
                  <strong>Bill Amount:</strong> ₹
                  {purchase?.bill_amount
                    ? Number(purchase.bill_amount).toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                      })
                    : '0.00'}
                </div>
              </div>
            );

            return (
              <Tooltip title={tooltipContent} placement="topLeft">
                <div style={{ cursor: 'pointer' }}>
                  <Text style={{ fontWeight: 500, color: '#1890ff' }}>
                    {purchase?.id ? `#${purchase.id}` : '-'}
                  </Text>
                </div>
              </Tooltip>
            );
          },
        },
        {
          key: 'amount',
          title: 'Amount',
          dataIndex: 'amount',
          sorter: true,
          minWidth: 150,
          render: (value: number) => (
            <Tag
              color="green"
              style={{ margin: 0, fontSize: '14px', fontWeight: 500 }}
            >
              ₹
              {value
                ? Number(value).toLocaleString('en-IN', {
                    minimumFractionDigits: 2,
                  })
                : '0.00'}
            </Tag>
          ),
        },
        {
          key: 'transaction_type',
          title: 'Payment Type',
          dataIndex: 'transaction_type',
          sorter: true,
          minWidth: 150,
          render: renderPaymentType,
        },
        {
          key: 'created_at',
          title: 'User & Timestamp',
          dataIndex: 'created_at',
          sorter: false,
          minWidth: 180,
          render: (value: any, record: any) => userTimestampRender(record),
        },
      ],
      [userTimestampRender, renderPaymentType]
    );
  };
